//import conf from 'src/../vue.config.js'
// const conf = require('src/../vue.config.js')
//
// export const getVersion = function({ commit }) {
//   return fetch(`${conf.baseUrl}version.json`)
//     .then((response) => {
//       return response.json()
//     })
//     .then((json) => {
//       commit('setVersion', json)
//     })
// }

export const getVersion = function({ commit }) {
  return fetch('version.json')
    .then((response) => {
      return response.json()
    })
    .then((json) => {
      commit('setVersion', json)
    })
}